
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asset/bond",
      function () {
        return require("private-next-pages/asset/bond.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asset/bond"])
      });
    }
  